import { React, useState, useEffect } from 'react';
import { Nav, Row, Form, Col, Button } from 'react-bootstrap';
import * as Yup from "yup";
import { useFormik } from 'formik';
import '../settingscommon.scss';
import '../User/user.scss';
import PhotoUpload from './PhotoUpload';
import ChangePassword from './ChangePassword';
import { useLazyQuery, useMutation } from '@apollo/client';
import { Link, withRouter } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { GET_PROFILE } from '../../../gql/auth/queries';
import { UPDATE_PROFILE } from '../../../gql/auth/mutation';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const User = ({ history }) => {

  const [email, setEmail] = useState('')
  const [fName, setFName] = useState('')
  const [lName, setLName] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [updatedProfile, setUpdatedProfile] = useState(false)

  const [loadUser, { loading, error }] = useLazyQuery(GET_PROFILE, {
    onCompleted(data) {
      setEmail(data?.me?.email)
      setFName(data?.me?.firstName)
      setLName(data?.me?.lastName)
    },
    onError(error) {
      if (error) {
        if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
          setErrorMessage("Check Your Network, Your Browser Is Offline")
        }
        if (error.message) {
          setErrorMessage(error.message)
        }
        if (!error.message) {
          setErrorMessage("Something Went Wrong !")
        }
      }
    }
  });

  const [updateProfile, { loading: updateProfileLoading}] = useMutation(UPDATE_PROFILE, {
    onCompleted(data){
      setUpdatedProfile(true)
    },
    onError(error) {
      if (error) {
        if (error.networkError && typeof window !== 'undefined' && !window.navigator.onLine) {
          setErrorMessage("Check Your Network, Your Browser Is Offline")
        }
        if (error.message) {
          setErrorMessage(error.message)
        }
        if (!error.message) {
          setErrorMessage("Something Went Wrong !")
        }
      }
    },
    refetchQueries: [
      'Me'
    ]
  })

  useEffect(() => {
    const userToken = localStorage.getItem('token')
    const userRToken = localStorage.getItem('token')
    const userInfo = JSON.parse(localStorage.getItem('user'))
    const name = userInfo?.name
    if (!userToken && !userRToken && !name) {
      return history.push('/')
    }
    loadUser()
    // eslint-disable-next-line
  }, [history])


  const formik = useFormik({
    initialValues: {
      firstName: fName,
      lastName: lName,
    },
    validationSchema: Yup.object({
      firstName: Yup.string()
        .required("First name is required")
        .matches(/[A-Za-z]$/, "First name should contain characters only"),
      lastName: Yup.string()
        .matches(/[A-Za-z]$/, "Last name should contain characters only"),
    }),
    enableReinitialize: true,
    onSubmit: (values) => {
      const inputData = {
        firstName: values.firstName,
        lastName: values.lastName,
      }
      try {
        updateProfile({
          variables: {
            updateProfileInput: inputData
          }
        })
      }
      catch (e) {
        console.error(e)
      }
    }
  })

  if (loading && !error) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '500px' }}>
      <Spinner
        as="span"
        animation="border"
        size="lg"
        role="status"
        aria-hidden="true"
        variant='primary'
        style={{
          width: "100px",
          height: "100px",
          margin: "auto",
          display: "block"
        }}
      />
    </div>
  }

  if (error) {
    return <h2>Something Went Wrong !</h2>
  }

  if(errorMessage){
    toast.error(errorMessage, {
      position: "bottom-right",
    })
    setErrorMessage('')
  }

  if (updatedProfile) {
    toast.success("Profile Information Updated Successfully.", {
      position: "bottom-right",
    })

    setUpdatedProfile(false)

  }


  return <>
    <div>
      <h1 className='page-title'>Settings</h1>
      <Nav
        className='setting-menu'
      >
        <Nav.Item>
          <Link to="/settings/user" className='nav-link active'>User</Link>
        </Nav.Item>
        <Nav.Item>
          <Link to="/settings/email-provider" className='nav-link'>Email Provider</Link>
        </Nav.Item>
        <Nav.Item>
          <Link to="/settings/text-provider" className='nav-link'>SMS Provider</Link>
        </Nav.Item>
        <Nav.Item>
          <Link to="/settings/email-signature" className='nav-link'>Email Signature</Link>
        </Nav.Item>
        {/* <Nav.Item>
          <Link to="/settings/billing" className='nav-link'>Billing</Link>
        </Nav.Item> */}
      </Nav>
      <div className='profile-sec'>
        <h4>Profile</h4>
        <p>Update your photo and personal details here</p>
        <PhotoUpload />
        <Form className='profile-form' onSubmit={formik.handleSubmit}>
          <Row>
            <Form.Group className="mb-4" as={Col} md="6" controlId="firstName">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                name="firstName"
                type="text"
                placeholder=""
                value={formik.values.firstName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className={formik.errors.firstName && formik.touched.firstName && "error"}
              />
              {formik.errors.firstName && formik.touched.firstName && (
                <div className="input-feedback">{formik.errors.firstName}</div>
              )}
            </Form.Group>
            <Form.Group className="mb-4" as={Col} md="6" controlId="lastName">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                name="lastName"
                type="text"
                placeholder=""
                value={formik.values.lastName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className={formik.errors.lastName && formik.touched.lastName && "error"}
              />
              {formik.errors.lastName && formik.touched.lastName && (
                <div className="input-feedback">{formik.errors.lastName}</div>
              )}
            </Form.Group>
          </Row>
          <Row>
            <Form.Group className="mb-4" as={Col} md="6" controlId="email">
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                name="email"
                type="text"
                value={email}
                readOnly
              />
              {/* {formik.errors.email && formik.touched.email && (
              <div className="input-feedback">{formik.errors.email}</div>
            )} */}
            </Form.Group>
          </Row>
          <Row>
            <Form.Group className="mt-2" as={Col} md="6">
              {
                updateProfileLoading  ?
                  <Button className='solid-button'>Save Changes
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  </Button>
                  :
                  <Button className='solid-button' type="submit">Save Changes</Button>

              }
            </Form.Group>
          </Row>
        </Form>
      </div>
      <div className="section-divider"></div>
      <ChangePassword />
    </div>
  </>
}

export default withRouter(User);
